/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';

import classNames from 'classnames';
import styles from './ToggleButtonStyles.module.scss';

interface ToggleProps {
  toggleOn: boolean;
  onToggle?: (toggleOn: boolean) => void;
  className?: string;
  enabledText?: string;
  disabledText?: string;
  useRebrandStyling?: boolean;
}

export const ImageAnnotationToggle = ({
  toggleOn,
  onToggle = () => {},
  className,
  enabledText = 'Product bubbles on',
  disabledText = 'Product bubbles off',
  useRebrandStyling = false
}: ToggleProps) => {
  const handleClick = () => {
    onToggle(!toggleOn);
  };

  return (
    <div className={ classNames(className, styles.ToggleContainer) }>
      <div className={ styles.ButtonContainer }>
        <div
          className={ classNames(
            styles.Slider,
            { [styles.SliderOn]: toggleOn && !useRebrandStyling },
            { [styles.SliderOnRebrand]: toggleOn && useRebrandStyling }
          )}
          onClick={ () => handleClick() }
        />
        <div
          className={ classNames(
            styles.SliderCircle,
            { [styles.SliderCircleOn]: toggleOn && !useRebrandStyling },
            { [styles.SliderCircleOnRebrand]: toggleOn && useRebrandStyling }
          )}
          onClick={ () => handleClick() }
        />
      </div>
      <div className={ styles.ButtonTextContainer }>
        <div className={classNames(
          styles.ToggleText,
          { [styles.ToggleTextRebrand]: useRebrandStyling }
        )}
        >
          { toggleOn ? enabledText : disabledText }
        </div>
      </div>
    </div>
  );
};

export default ImageAnnotationToggle;
